import { FirmImageApi } from "@/api";
import i18n from "@/i18n";
import { showErrorSnackbar, showSuccessSnackbar } from "@/utilities/snackbar";

export async function getSignedUrlFromFirm(firmId) {
  const { data } = await FirmImageApi.getActiveImageUrl(firmId);
  return data;
}

export async function remove(firmId, firmImageId) {
  let response = "";
  try {
    response = (await FirmImageApi.remove(firmId, firmImageId)).data;
  } catch (ex) {
    showErrorSnackbar(undefined, i18n.t("something-went-wrong") + ex);
  }
  if (response !== "") {
    showSuccessSnackbar(200, response);
  }
}

export async function getUploadUrl(firmId, file) {
  const request = {
    fileName: file.name,
    contentType: file.type,
  };
  const { data } = await FirmImageApi.getUploadUrl(firmId, request);
  return data;
}

export async function confirmUpload(firmId, file, hash, userId) {
  const request = {
    fileName: file.name,
    contentType: file.type,
    hash: hash,
    userId: userId,
  };
  const { data } = await FirmImageApi.confirmUpload(firmId, request);
  return data;
}
